import { useEffect, useState } from 'react'
import { apiGetDayTrips, type DayTrip } from '../api/dayTrips/dayTripApi'

type DayTripDropdownProps = {
  onSelect: (tripId: string) => void
  className?: string
}

export default function DayTripDropdown({
  onSelect,
  className = '',
}: DayTripDropdownProps) {
  const [trips, setTrips] = useState<DayTrip[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let mounted = true
    apiGetDayTrips()
      .then((res) => {
        if (mounted && res?.data) {
          setTrips(res.data)
        }
      })
      .catch(() => {})
      .finally(() => {
        if (mounted) setLoading(false)
      })

    return () => {
      mounted = false
    }
  }, [])

  return (
    <div
      className={`
        from-dropdown-scrollbar
        absolute
        left-0
        top-[calc(100%+16px)]
        z-[100]
        max-h-[380px]
        w-full
        overflow-y-auto
        rounded-[15px]
        bg-white
        p-4
        shadow-[0_8px_22px_rgba(0,0,0,0.25)]
        ${className}
      `}
      role="listbox"
    >
      {loading ? (
        <div className="py-6 text-center font-host text-[14px] text-gray-500">
          Loading day trips...
        </div>
      ) : trips.length === 0 ? (
        <div className="py-6 text-center font-host text-[14px] text-gray-500">
          No day trips found
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
          {trips.map((trip) => (
            <button
              key={trip.id}
              type="button"
              onClick={() => onSelect(trip.id)}
              className="flex items-center gap-3 rounded-[12px] border border-transparent p-2 text-left transition-all hover:border-[#D1D1D1] hover:bg-[#F8F8F8] focus:border-[#D1D1D1] focus:bg-[#F8F8F8] outline-none"
            >
              <div className="h-16 w-16 shrink-0 overflow-hidden rounded-[8px] bg-slate-100">
                <img
                  src={trip.images?.[0] || trip.image || '/assets/images/day-trip-hallstatt.png'}
                  alt={trip.title}
                  className="h-full w-full object-cover"
                />
              </div>

              <div className="min-w-0 flex-1">
                <h4 className="truncate font-host text-[14px] font-bold text-[#111111]">
                  {trip.title}
                </h4>
                <p className="truncate font-poppins text-[11px] text-[#666666]">
                  {trip.duration}
                </p>
                <p className="mt-1 flex items-center gap-1 font-poppins text-[12px] font-semibold text-[#9BC344]">
                  <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      className="text-brand-green"
                    >
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                      <circle cx="9" cy="7" r="4" />
                    </svg>{trip.maxPeople}
                </p>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
